
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/sasongsavslutning-for-skidorter",
      function () {
        return require("private-next-pages/[region]/sasongsavslutning-for-skidorter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/sasongsavslutning-for-skidorter"])
      });
    }
  